import styled from 'styled-components';
import { materialSMBreakpoint } from 'assets/theme/sizes';

export const Wrapper = styled.div`
  display: flex;
  width: 100%;
  margin: auto;

  @media (min-width: ${materialSMBreakpoint}) {
    position: absolute;
    left: 0;
  }
`;
